import React from 'react';

const MedMapDrawOverlay = () => {
  return <div>MedMapDrawOverlay</div>;
};

export default MedMapDrawOverlay;
